import { useCallback, useRef, useState } from 'react';
import { isFunction } from 'lodash-es';

interface ImagePreviewModalControlProps {
  onClose?: () => void;
}

export interface ImagePreviewModalViewProps {
  onClose: () => void;
  show: boolean;
}

interface ImagePreviewModalControlResponse {
  openModal: () => void;
  closeModal: () => void;
  modalProps: ImagePreviewModalViewProps;
  triggerProps: {
    onClick: (e?: React.SyntheticEvent) => void;
    ref: React.Ref<any>;
  };
}

export function useImagePreviewModalControl({
  onClose,
}: ImagePreviewModalControlProps = {}): ImagePreviewModalControlResponse {
  const [show, setShow] = useState(false);
  const triggerRef = useRef(null);
  const openModal = useCallback(() => {
    setShow(true);
  }, []);

  const closeModal = useCallback(() => {
    setShow(false);
    if (isFunction(onClose)) onClose?.();
  }, [onClose]);

  return {
    openModal,
    closeModal,
    modalProps: {
      onClose: closeModal,
      show,
    },
    triggerProps: {
      onClick: (e) => {
        e?.stopPropagation?.();
        openModal();
      },
      ref: triggerRef,
    },
  };
}
